import View from 'ln/view/View';
import Node from 'ln/node/Node';
import ListRenderer from 'ln/list/ListRenderer';
import UserFileModel from '../models/UserFileModel';
import UserFileView from './UserFileView';
import UserSequenceModel from '../models/UserSequenceModel';
import setup from 'ln/setup/setup';
import { backend } from '../../setup';
import SlrgUserSequenceModel from '../models/SlrgUserSequenceModel';

class UserFileList extends View {

	public fileRenderer:ListRenderer<UserFileModel>;
	public sequence:UserSequenceModel|SlrgUserSequenceModel;

	constructor( sequence:UserSequenceModel|SlrgUserSequenceModel){
		super();
		this.sequence = sequence;
		this.defaultTemplate = 'krw.userfilelist';
	}

	public init(){
		
		this.fileRenderer = new ListRenderer<UserFileModel>( this.node.js( 'userfiles') );
		
		this.fileRenderer.defaultRender( ( model:UserFileModel ) => {
			var view = new UserFileView( model, this.sequence );
			view.render();
			return { node: view.node };
		});

		this.fileRenderer.source = this.sequence.userfiles;
		
		// listen for removed userfiles on the list
		this.sequence.userfiles.removed.add( this.onUserFileDeleted, this );

		// listen for file upload
		this.node.js( 'upload' ).click.add( () => {
			var e = document.createEvent( 'MouseEvent' );
			if( e ){
				e.initEvent( 'click', true, true );
				this.node.one( 'input[type=file]' ).native.dispatchEvent( e )
			}
		});

		// upload files
		this.node.one( 'input[type=file]' ).change.add( this.uploadFiles, this );
	}

	/**
	 * Callback for the fileupload
	 */
	private uploadFiles( n:Node ) {
		var fileList = this.sequence.userfiles;
		var sequence = this.sequence;

		var fileinput = <HTMLInputElement> n.native;
		var files = fileinput.files;

		var fData = new FormData();
		for( var i = 0; i < files.length; i++ ){
			fData.append( 'files[]', files[i], files[i].name );
		}
		
		// upload the userfiles
		setup.route( 'api.userfiles.upload' ).send( fData ).then( ( value:string ) => {

			var userFileModels = backend.mapper.model( value ) as UserFileModel[];

			userFileModels.forEach( ( model ) => {
				fileList.append( model );
			});

			sequence.save();
			
		});
	}

	private onUserFileDeleted( model:UserFileModel, index:number ){
		this.sequence.save();
		model.delete();

	}

}

export default UserFileList;